<template>
    <section style="min-width: 1400px;">
        <div class="box">
            <div class="nav_box">
                <Menu mode="horizontal" theme="light" :active-name="activeName">
                    <!-- <MenuItem name="1">
                        <img src="@/assets/logo.png" alt="海马行">
                    </MenuItem> -->
                    <div class="logo_box" :to="{name: 'index'}">
                        <img src="@/assets/logo.png" alt="海马行">
                    </div>
                    <MenuItem name="1" :to="{name: 'index'}">首页</MenuItem>
                    <MenuItem name="2" :to="{name: 'newActive'}">最新动态</MenuItem>
                    <MenuItem name="3" :to="{name: 'productIntro'}">产品介绍</MenuItem>
                    <MenuItem name="4" :to="{name: 'aboutUs'}">关于我们</MenuItem>
                    <MenuItem name="5" :to="{name: 'applyUse'}">申请试用</MenuItem>
                    <Submenu name='6'>
                        <template slot="title">
                            商户登录
                        </template>
                        <a href="https://www.up-zy.com/marke/#/login" target="_blank">
                            <MenuItem name='6-1'>单站</MenuItem>
                        </a>
                        <a href="https://www.up-zy.com/groupMarke/#/login" target="_blank">
                            <MenuItem name='6-2'>集团</MenuItem>
                        </a>
                    </Submenu>
                    <MenuItem name="7" :to="{name: 'APPdownload'}">APP下载</MenuItem>
                </Menu>
            </div>
        </div>
        <div style="height:80px;"></div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                activeName: 1,
            }
        },
        methods: {
            selected(){
                switch(this.$route.name){
                    case 'index':
                        this.activeName = '1'
                        break;
                    case 'newActive':
                        this.activeName = '2'
                        break;
                    case 'productIntro':
                        this.activeName = '3'
                        break;
                    case 'aboutUs':
                        this.activeName = '4'
                        break;
                    case 'applyUse':
                        this.activeName = '5'
                        break;
                    case 'APPdownload':
                        this.activeName = '7'
                        break;
                }
            }
        },
        mounted() {
            setTimeout(()=>{
                this.selected()
            },1000)
        },
    }
</script>
<style scoped>
    .box{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        z-index: 999;
        min-width: 1400px;
    }
    .ivu-menu-horizontal{
        height: 80px;
        line-height: 80px;
    }
    .nav_box{
        width: 1200px;
        margin: 0 auto;
        text-align: right;
    }
    .logo_box{
        float: left;
        height: 80px;
        margin-left: 100px;
        margin-right: 200px;
        padding-top: 10px;
    }
    .ivu-menu-horizontal.ivu-menu-light:after{
        height: 0;
    }
    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active, 
    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active{
        color: #fff;
        border-bottom: 2px solid #2d8cf0;
        background-color: #2d8cf0;
    }
    .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item{
        text-align: center;
    }
</style>
